import React from "react";
import { MdLocationOn, MdExpandMore } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useFacility from "../../../utils/hooks/useFacility";
import { getLinkedFacilitiesFor } from "../../../utils/linkedFacilitiesConfig";
import { updateFacilityIds, getConfigurationFacility } from "../../../app/store/config/configActions";
import { clearStepSaleConfig, getStepSaleConfig } from "../../../app/store/stepSaleConfig/saleStepConfigActions";
import { LOGIN_PAGE } from "../../../app/routes";

const LinkedFacilitiesSwitcher: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const currentFacilityId = useFacility();

  const linkedFacilities = currentFacilityId ? getLinkedFacilitiesFor(currentFacilityId) : [];

  if (!currentFacilityId || linkedFacilities.length <= 1) {
    return null;
  }

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newId = event.target.value;

    if (!newId || newId === currentFacilityId) {
      return;
    }

    const selectedFacility = linkedFacilities.find((facility) => facility.facilityId === newId);

    dispatch(updateFacilityIds(newId));
    sessionStorage.setItem("facilityId", newId);

    dispatch(clearStepSaleConfig());
    dispatch(getConfigurationFacility(newId));
    dispatch(getStepSaleConfig(newId));

    const basePath = selectedFacility?.redirectPath || location.pathname;
    const targetUrl = new URL(window.location.origin + basePath);
    targetUrl.searchParams.set("id", newId);

    if (location.pathname !== LOGIN_PAGE) {
      navigate(targetUrl.pathname + targetUrl.search, { replace: true });
    } else {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("id", newId);
      window.history.replaceState({}, "", currentUrl.toString());
    }
  };

  return (
    <div className="nav-linked-facilities">
      <div className="nav-linked-facilities__select-wrapper">
        <MdLocationOn className="nav-linked-facilities__icon" />
        <select
          name="linked-facilities"
          value={currentFacilityId}
          onChange={handleChange}
          className="nav-linked-facilities__select"
        >
          {linkedFacilities.map((facility) => (
            <option key={facility.facilityId} value={facility.facilityId}>
              {facility.name}
            </option>
          ))}
        </select>
        <MdExpandMore className="nav-linked-facilities__arrow" />
      </div>
    </div>
  );
};

export default LinkedFacilitiesSwitcher;

